/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PageRouteImport } from './routes/page'
import { Route as ReportsRouteRouteImport } from './routes/reports/route'
import { Route as SettingsRouteRouteImport } from './routes/settings/route'
import { Route as CompetitionPageRouteImport } from './routes/competition/page'
import { Route as DashboardPageRouteImport } from './routes/dashboard/page'
import { Route as ElementsExplorerPageRouteImport } from './routes/elements-explorer/page'
import { Route as ExplorePageRouteImport } from './routes/explore/page'
import { Route as GuidebookPageRouteImport } from './routes/guidebook/page'
import { Route as LoginPageRouteImport } from './routes/login/page'
import { Route as MediaPageRouteImport } from './routes/media/page'
import { Route as OutcomesPageRouteImport } from './routes/outcomes/page'
import { Route as SettingsPageRouteImport } from './routes/settings/page'
import { Route as SignalsPageRouteImport } from './routes/signals/page'
import { Route as StudioPageRouteImport } from './routes/studio/page'
import { Route as WorkflowsPageRouteImport } from './routes/workflows/page'
import { Route as FlightCheckAnalysisPageRouteImport } from './routes/flight-check/analysis/page'
import { Route as FlightCheckDashboardPageRouteImport } from './routes/flight-check/dashboard/page'
import { Route as InvitesAcceptPageRouteImport } from './routes/invites/accept/page'
import { Route as LoginSignInPageRouteImport } from './routes/login/sign-in/page'
import { Route as ReportsPerformancePageRouteImport } from './routes/reports/performance/page'
import { Route as SettingsIntegrationsPageRouteImport } from './routes/settings/integrations/page'
import { Route as SettingsNotificationsPageRouteImport } from './routes/settings/notifications/page'
import { Route as SettingsUsersPageRouteImport } from './routes/settings/users/page'
import { Route as WorkflowsWorkflowIdPageRouteImport } from './routes/workflows/$workflowId/page'

const PageRoute = PageRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRouteRoute = ReportsRouteRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRouteRoute = SettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const CompetitionPageRoute = CompetitionPageRouteImport.update({
  id: '/competition/',
  path: '/competition/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardPageRoute = DashboardPageRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const ElementsExplorerPageRoute = ElementsExplorerPageRouteImport.update({
  id: '/elements-explorer/',
  path: '/elements-explorer/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExplorePageRoute = ExplorePageRouteImport.update({
  id: '/explore/',
  path: '/explore/',
  getParentRoute: () => rootRouteImport,
} as any)
const GuidebookPageRoute = GuidebookPageRouteImport.update({
  id: '/guidebook/',
  path: '/guidebook/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginPageRoute = LoginPageRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const MediaPageRoute = MediaPageRouteImport.update({
  id: '/media/',
  path: '/media/',
  getParentRoute: () => rootRouteImport,
} as any)
const OutcomesPageRoute = OutcomesPageRouteImport.update({
  id: '/outcomes/',
  path: '/outcomes/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsPageRoute = SettingsPageRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SignalsPageRoute = SignalsPageRouteImport.update({
  id: '/signals/',
  path: '/signals/',
  getParentRoute: () => rootRouteImport,
} as any)
const StudioPageRoute = StudioPageRouteImport.update({
  id: '/studio/',
  path: '/studio/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkflowsPageRoute = WorkflowsPageRouteImport.update({
  id: '/workflows/',
  path: '/workflows/',
  getParentRoute: () => rootRouteImport,
} as any)
const FlightCheckAnalysisPageRoute = FlightCheckAnalysisPageRouteImport.update({
  id: '/flight-check/analysis/',
  path: '/flight-check/analysis/',
  getParentRoute: () => rootRouteImport,
} as any)
const FlightCheckDashboardPageRoute =
  FlightCheckDashboardPageRouteImport.update({
    id: '/flight-check/dashboard/',
    path: '/flight-check/dashboard/',
    getParentRoute: () => rootRouteImport,
  } as any)
const InvitesAcceptPageRoute = InvitesAcceptPageRouteImport.update({
  id: '/invites/accept/',
  path: '/invites/accept/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginSignInPageRoute = LoginSignInPageRouteImport.update({
  id: '/login/sign-in/',
  path: '/login/sign-in/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsPerformancePageRoute = ReportsPerformancePageRouteImport.update({
  id: '/performance/',
  path: '/performance/',
  getParentRoute: () => ReportsRouteRoute,
} as any)
const SettingsIntegrationsPageRoute =
  SettingsIntegrationsPageRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsNotificationsPageRoute =
  SettingsNotificationsPageRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => SettingsRouteRoute,
  } as any)
const SettingsUsersPageRoute = SettingsUsersPageRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const WorkflowsWorkflowIdPageRoute = WorkflowsWorkflowIdPageRouteImport.update({
  id: '/workflows/$workflowId/',
  path: '/workflows/$workflowId/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof PageRoute
  '/reports': typeof ReportsRouteRouteWithChildren
  '/settings': typeof SettingsRouteRouteWithChildren
  '/competition/': typeof CompetitionPageRoute
  '/dashboard/': typeof DashboardPageRoute
  '/elements-explorer/': typeof ElementsExplorerPageRoute
  '/explore/': typeof ExplorePageRoute
  '/guidebook/': typeof GuidebookPageRoute
  '/login/': typeof LoginPageRoute
  '/media/': typeof MediaPageRoute
  '/outcomes/': typeof OutcomesPageRoute
  '/settings/': typeof SettingsPageRoute
  '/signals/': typeof SignalsPageRoute
  '/studio/': typeof StudioPageRoute
  '/workflows/': typeof WorkflowsPageRoute
  '/flight-check/analysis/': typeof FlightCheckAnalysisPageRoute
  '/flight-check/dashboard/': typeof FlightCheckDashboardPageRoute
  '/invites/accept/': typeof InvitesAcceptPageRoute
  '/login/sign-in/': typeof LoginSignInPageRoute
  '/reports/performance/': typeof ReportsPerformancePageRoute
  '/settings/integrations/': typeof SettingsIntegrationsPageRoute
  '/settings/notifications/': typeof SettingsNotificationsPageRoute
  '/settings/users/': typeof SettingsUsersPageRoute
  '/workflows/$workflowId/': typeof WorkflowsWorkflowIdPageRoute
}
export interface FileRoutesByTo {
  '/': typeof PageRoute
  '/reports': typeof ReportsRouteRouteWithChildren
  '/competition': typeof CompetitionPageRoute
  '/dashboard': typeof DashboardPageRoute
  '/elements-explorer': typeof ElementsExplorerPageRoute
  '/explore': typeof ExplorePageRoute
  '/guidebook': typeof GuidebookPageRoute
  '/login': typeof LoginPageRoute
  '/media': typeof MediaPageRoute
  '/outcomes': typeof OutcomesPageRoute
  '/settings': typeof SettingsPageRoute
  '/signals': typeof SignalsPageRoute
  '/studio': typeof StudioPageRoute
  '/workflows': typeof WorkflowsPageRoute
  '/flight-check/analysis': typeof FlightCheckAnalysisPageRoute
  '/flight-check/dashboard': typeof FlightCheckDashboardPageRoute
  '/invites/accept': typeof InvitesAcceptPageRoute
  '/login/sign-in': typeof LoginSignInPageRoute
  '/reports/performance': typeof ReportsPerformancePageRoute
  '/settings/integrations': typeof SettingsIntegrationsPageRoute
  '/settings/notifications': typeof SettingsNotificationsPageRoute
  '/settings/users': typeof SettingsUsersPageRoute
  '/workflows/$workflowId': typeof WorkflowsWorkflowIdPageRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof PageRoute
  '/reports': typeof ReportsRouteRouteWithChildren
  '/settings': typeof SettingsRouteRouteWithChildren
  '/competition/': typeof CompetitionPageRoute
  '/dashboard/': typeof DashboardPageRoute
  '/elements-explorer/': typeof ElementsExplorerPageRoute
  '/explore/': typeof ExplorePageRoute
  '/guidebook/': typeof GuidebookPageRoute
  '/login/': typeof LoginPageRoute
  '/media/': typeof MediaPageRoute
  '/outcomes/': typeof OutcomesPageRoute
  '/settings/': typeof SettingsPageRoute
  '/signals/': typeof SignalsPageRoute
  '/studio/': typeof StudioPageRoute
  '/workflows/': typeof WorkflowsPageRoute
  '/flight-check/analysis/': typeof FlightCheckAnalysisPageRoute
  '/flight-check/dashboard/': typeof FlightCheckDashboardPageRoute
  '/invites/accept/': typeof InvitesAcceptPageRoute
  '/login/sign-in/': typeof LoginSignInPageRoute
  '/reports/performance/': typeof ReportsPerformancePageRoute
  '/settings/integrations/': typeof SettingsIntegrationsPageRoute
  '/settings/notifications/': typeof SettingsNotificationsPageRoute
  '/settings/users/': typeof SettingsUsersPageRoute
  '/workflows/$workflowId/': typeof WorkflowsWorkflowIdPageRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/reports'
    | '/settings'
    | '/competition/'
    | '/dashboard/'
    | '/elements-explorer/'
    | '/explore/'
    | '/guidebook/'
    | '/login/'
    | '/media/'
    | '/outcomes/'
    | '/settings/'
    | '/signals/'
    | '/studio/'
    | '/workflows/'
    | '/flight-check/analysis/'
    | '/flight-check/dashboard/'
    | '/invites/accept/'
    | '/login/sign-in/'
    | '/reports/performance/'
    | '/settings/integrations/'
    | '/settings/notifications/'
    | '/settings/users/'
    | '/workflows/$workflowId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/reports'
    | '/competition'
    | '/dashboard'
    | '/elements-explorer'
    | '/explore'
    | '/guidebook'
    | '/login'
    | '/media'
    | '/outcomes'
    | '/settings'
    | '/signals'
    | '/studio'
    | '/workflows'
    | '/flight-check/analysis'
    | '/flight-check/dashboard'
    | '/invites/accept'
    | '/login/sign-in'
    | '/reports/performance'
    | '/settings/integrations'
    | '/settings/notifications'
    | '/settings/users'
    | '/workflows/$workflowId'
  id:
    | '__root__'
    | '/'
    | '/reports'
    | '/settings'
    | '/competition/'
    | '/dashboard/'
    | '/elements-explorer/'
    | '/explore/'
    | '/guidebook/'
    | '/login/'
    | '/media/'
    | '/outcomes/'
    | '/settings/'
    | '/signals/'
    | '/studio/'
    | '/workflows/'
    | '/flight-check/analysis/'
    | '/flight-check/dashboard/'
    | '/invites/accept/'
    | '/login/sign-in/'
    | '/reports/performance/'
    | '/settings/integrations/'
    | '/settings/notifications/'
    | '/settings/users/'
    | '/workflows/$workflowId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  PageRoute: typeof PageRoute
  ReportsRouteRoute: typeof ReportsRouteRouteWithChildren
  SettingsRouteRoute: typeof SettingsRouteRouteWithChildren
  CompetitionPageRoute: typeof CompetitionPageRoute
  DashboardPageRoute: typeof DashboardPageRoute
  ElementsExplorerPageRoute: typeof ElementsExplorerPageRoute
  ExplorePageRoute: typeof ExplorePageRoute
  GuidebookPageRoute: typeof GuidebookPageRoute
  LoginPageRoute: typeof LoginPageRoute
  MediaPageRoute: typeof MediaPageRoute
  OutcomesPageRoute: typeof OutcomesPageRoute
  SignalsPageRoute: typeof SignalsPageRoute
  StudioPageRoute: typeof StudioPageRoute
  WorkflowsPageRoute: typeof WorkflowsPageRoute
  FlightCheckAnalysisPageRoute: typeof FlightCheckAnalysisPageRoute
  FlightCheckDashboardPageRoute: typeof FlightCheckDashboardPageRoute
  InvitesAcceptPageRoute: typeof InvitesAcceptPageRoute
  LoginSignInPageRoute: typeof LoginSignInPageRoute
  WorkflowsWorkflowIdPageRoute: typeof WorkflowsWorkflowIdPageRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/competition/': {
      id: '/competition/'
      path: '/competition'
      fullPath: '/competition/'
      preLoaderRoute: typeof CompetitionPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/elements-explorer/': {
      id: '/elements-explorer/'
      path: '/elements-explorer'
      fullPath: '/elements-explorer/'
      preLoaderRoute: typeof ElementsExplorerPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explore/': {
      id: '/explore/'
      path: '/explore'
      fullPath: '/explore/'
      preLoaderRoute: typeof ExplorePageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guidebook/': {
      id: '/guidebook/'
      path: '/guidebook'
      fullPath: '/guidebook/'
      preLoaderRoute: typeof GuidebookPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/media/': {
      id: '/media/'
      path: '/media'
      fullPath: '/media/'
      preLoaderRoute: typeof MediaPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/outcomes/': {
      id: '/outcomes/'
      path: '/outcomes'
      fullPath: '/outcomes/'
      preLoaderRoute: typeof OutcomesPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsPageRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/signals/': {
      id: '/signals/'
      path: '/signals'
      fullPath: '/signals/'
      preLoaderRoute: typeof SignalsPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studio/': {
      id: '/studio/'
      path: '/studio'
      fullPath: '/studio/'
      preLoaderRoute: typeof StudioPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workflows/': {
      id: '/workflows/'
      path: '/workflows'
      fullPath: '/workflows/'
      preLoaderRoute: typeof WorkflowsPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flight-check/analysis/': {
      id: '/flight-check/analysis/'
      path: '/flight-check/analysis'
      fullPath: '/flight-check/analysis/'
      preLoaderRoute: typeof FlightCheckAnalysisPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flight-check/dashboard/': {
      id: '/flight-check/dashboard/'
      path: '/flight-check/dashboard'
      fullPath: '/flight-check/dashboard/'
      preLoaderRoute: typeof FlightCheckDashboardPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invites/accept/': {
      id: '/invites/accept/'
      path: '/invites/accept'
      fullPath: '/invites/accept/'
      preLoaderRoute: typeof InvitesAcceptPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/sign-in/': {
      id: '/login/sign-in/'
      path: '/login/sign-in'
      fullPath: '/login/sign-in/'
      preLoaderRoute: typeof LoginSignInPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/performance/': {
      id: '/reports/performance/'
      path: '/performance'
      fullPath: '/reports/performance/'
      preLoaderRoute: typeof ReportsPerformancePageRouteImport
      parentRoute: typeof ReportsRouteRoute
    }
    '/settings/integrations/': {
      id: '/settings/integrations/'
      path: '/integrations'
      fullPath: '/settings/integrations/'
      preLoaderRoute: typeof SettingsIntegrationsPageRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/notifications/': {
      id: '/settings/notifications/'
      path: '/notifications'
      fullPath: '/settings/notifications/'
      preLoaderRoute: typeof SettingsNotificationsPageRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/users/': {
      id: '/settings/users/'
      path: '/users'
      fullPath: '/settings/users/'
      preLoaderRoute: typeof SettingsUsersPageRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/workflows/$workflowId/': {
      id: '/workflows/$workflowId/'
      path: '/workflows/$workflowId'
      fullPath: '/workflows/$workflowId/'
      preLoaderRoute: typeof WorkflowsWorkflowIdPageRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface ReportsRouteRouteChildren {
  ReportsPerformancePageRoute: typeof ReportsPerformancePageRoute
}

const ReportsRouteRouteChildren: ReportsRouteRouteChildren = {
  ReportsPerformancePageRoute: ReportsPerformancePageRoute,
}

const ReportsRouteRouteWithChildren = ReportsRouteRoute._addFileChildren(
  ReportsRouteRouteChildren,
)

interface SettingsRouteRouteChildren {
  SettingsPageRoute: typeof SettingsPageRoute
  SettingsIntegrationsPageRoute: typeof SettingsIntegrationsPageRoute
  SettingsNotificationsPageRoute: typeof SettingsNotificationsPageRoute
  SettingsUsersPageRoute: typeof SettingsUsersPageRoute
}

const SettingsRouteRouteChildren: SettingsRouteRouteChildren = {
  SettingsPageRoute: SettingsPageRoute,
  SettingsIntegrationsPageRoute: SettingsIntegrationsPageRoute,
  SettingsNotificationsPageRoute: SettingsNotificationsPageRoute,
  SettingsUsersPageRoute: SettingsUsersPageRoute,
}

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(
  SettingsRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  PageRoute: PageRoute,
  ReportsRouteRoute: ReportsRouteRouteWithChildren,
  SettingsRouteRoute: SettingsRouteRouteWithChildren,
  CompetitionPageRoute: CompetitionPageRoute,
  DashboardPageRoute: DashboardPageRoute,
  ElementsExplorerPageRoute: ElementsExplorerPageRoute,
  ExplorePageRoute: ExplorePageRoute,
  GuidebookPageRoute: GuidebookPageRoute,
  LoginPageRoute: LoginPageRoute,
  MediaPageRoute: MediaPageRoute,
  OutcomesPageRoute: OutcomesPageRoute,
  SignalsPageRoute: SignalsPageRoute,
  StudioPageRoute: StudioPageRoute,
  WorkflowsPageRoute: WorkflowsPageRoute,
  FlightCheckAnalysisPageRoute: FlightCheckAnalysisPageRoute,
  FlightCheckDashboardPageRoute: FlightCheckDashboardPageRoute,
  InvitesAcceptPageRoute: InvitesAcceptPageRoute,
  LoginSignInPageRoute: LoginSignInPageRoute,
  WorkflowsWorkflowIdPageRoute: WorkflowsWorkflowIdPageRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
